import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasFacturacionListaCliente', {
    controller: ContabilidadPolizasFacturacionListaClienteComponent,
    template,
    bindings: {
      cliente: '<',
      facturas: '<',
    },
  })

function ContabilidadPolizasFacturacionListaClienteComponent () {
  var $ctrl = this
  $ctrl.toggle = toggle

  $ctrl.cliente = undefined
  $ctrl.facturas = undefined
  $ctrl.expandido = true

  function toggle () {
    $ctrl.expandido = !$ctrl.expandido
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/facturacion/lista/cliente/component.js